<template>
  <div class="addExperiment">
    <div class="addExperiment-title">
      <span @click="goRouter('/experimentList')"
        >实验列表&nbsp;&nbsp; / &nbsp;&nbsp;</span
      >
      <i v-if="$route.query.id">编辑实验</i>
      <i v-else>添加实验</i>
    </div>
    <div class="addExperiment-content">
      <div class="list">
        <div class="list-top"><span>实验名称</span></div>
        <div class="list-bottom">
          <el-input
            v-model="experimentName"
            placeholder="请输入实验名称"
          ></el-input>
        </div>
      </div>
      <div class="list">
        <div class="list-top"><span>课程认定</span></div>
        <div class="list-bottom">
          <el-select v-model="levelVal" placeholder="请选择">
            <el-option
              v-for="item in levelList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="list">
        <div class="list-top"><span>所属学院</span></div>
        <div class="list-bottom">
          <el-select v-model="collegeId" placeholder="请选择">
            <el-option
              v-for="item in collegeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="list">
        <div class="list-top"><span>学科</span></div>
        <div class="list-bottom">
          <el-select v-model="subject" placeholder="请选择">
            <el-option
              v-for="item in subjectList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="list">
        <div class="list-top"><span>学时</span></div>
        <div class="list-bottom">
          <el-input v-model="classHour" placeholder="请输入学时"></el-input>
        </div>
      </div>
      <div class="list">
        <div class="list-top"><span>虚拟仿真链接地址</span></div>
        <div class="list-bottom">
          <el-input
            v-model="experimentUrl"
            placeholder="请输入链接地址"
          ></el-input>
        </div>
      </div>
      <div class="list">
        <div class="list-top">
          <span>学生名单</span
          ><em>请选择大小不超过5M的文件，支持xls，xlsx格式</em>
        </div>
        <div class="list-bottom">
          <el-button type="primary" @click="onClick">上传文件</el-button>
          <i v-if="uploadFiles" style="margin-left: 10px" class="font14px">{{
            uploadFiles.name
          }}</i>
          <input
            type="file"
            ref="uploadFile"
            @change="onChange"
            accept=".xls,.xlsx"
            style="display: none"
          />
          <div class="download" @click="download">
            <i class="el-icon-document"></i><strong>下载模板</strong>
          </div>
          <div class="download" @click="showStudentList">
            <strong>学生名单</strong>
          </div>
        </div>
      </div>
      <div class="list">
        <div class="list-top">
          <span>是否公开</span><em>公开后其他学校用户将可以查看您的实验</em>
        </div>
        <div class="list-bottom">
          <el-switch
            v-model="isPublic"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>
        </div>
      </div>
      <div class="list">
        <div class="list-top">
          <span>实验封面</span>
        </div>
        <div class="list-bottom">
          <UploadFileImg
            ref="updateUploadFile"
            width="824px"
            height="192px"
            tip="将文件拖拽到此处或单击上传"
            tip2="文件大小限制为30M"
            :whiteList="['jpg', 'png', 'gif']"
            accept=".png,.jpg"
            @onSucceed="uploadCover"
          ></UploadFileImg>
        </div>
      </div>
      <div class="list">
        <div class="list-top">
          <div
            class="list-top-tabs"
            @click="active = 0"
            :class="active == 0 ? 'addtabsActive' : ''"
          >
            <span>实验介绍</span>
          </div>
          <div
            class="list-top-tabs"
            @click="active = 1"
            :class="active == 1 ? 'addtabsActive' : ''"
          >
            <span>学习资料</span>
          </div>
        </div>
        <div class="list-bottom">
          <el-input
            v-if="active == 0"
            type="textarea"
            :rows="6"
            placeholder="请输入内容"
            v-model="experimentIntroduce"
          >
          </el-input>
          <div class="experimentalData" v-if="active == 1">
            <div class="studyFiles">
              <upload-file
                dir="/live/cover"
                accept=".pdf,.mp4"
                @on-success="handleUploadCoverSuccess"
                :maxSize="100"
              >
              </upload-file>
            </div>
            <div class="studyName">
              <p
                v-for="(item, index) in currentStudy"
                class="font14px"
                :key="item.id"
              >
                <span>{{ index + 1 }}、{{ item.name }}</span>
                <i
                  class="el-icon-close"
                  style="margin-left: 10px; cursor: pointer"
                  @click="delStudentWare(item.id)"
                ></i>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="list">
        <button class="btn" @click="goBack">取消</button>
        <button class="btn" @click="save">提交</button>
      </div>
      <el-button
        type="primary"
        class="goBack"
        @click="goRouter('/experimentList')"
        >返回</el-button
      >
    </div>
    <el-dialog title="学生名单" :visible.sync="dialogTableVisible">
      <!-- 新导入名单 -->
      <h3 class="dialogTitle">导入学生名单</h3>
      <Table
        ref="selection"
        :columns="columns"
        :data="newStudentList"
        @on-selection-change="checkNewStudent"
      >
      </Table>
      <!-- 原来的名单 -->
      <template v-if="isShowStudentList">
        <h3 class="dialogTitle" style="margin-top: 20px">已有学习名单</h3>
        <Table
          ref="selection"
          :columns="columns"
          :data="oldStudentList"
          @on-selection-change="checkOldStudent"
        >
        </Table>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import UploadFileImg from "@/components/common/UploadFile.vue";
import uploadFile from "@/components/common/upload-file.vue";
import util from "@/assets/util/util.js";
export default {
  name: "VirtualimitationAddexperiment",
  components: { UploadFileImg, uploadFile },
  data() {
    return {
      active: 0,
      experimentName: "", //实验名称
      classHour: 0, //学时
      experimentUrl: "", //实验地址
      isPublic: false, //是否公开
      uploadFiles: null, //上传的学生名单
      experimentCover: "", //实验封面
      experimentIntroduce: "", //实验介绍
      userIds: [], //学生名单
      currentStudy: [], //当前上传的全部学习资料
      collegeId: "", //学院id
      collegeList: [], //学院列表
      subject: "", //学科
      subjectList: [], //学科列表
      levelVal: "", //课程认定的值
      levelList: [
        {
          value: 1,
          label: "国家级",
        },
        {
          value: 2,
          label: "省级",
        },
        {
          value: 3,
          label: "市级",
        },
        {
          value: 4,
          label: "其他",
        },
      ],
      updateExperimentObj: {},
      oldStudentList: [], //已有学生名单
      newStudentList: [], //导入学生名单
      checkOldStudentIDS: [], //选中的已有学生名单
      checkNewStudentIDS: [], //选中的导入学生名单
      dialogTableVisible: false,
      columns: [
        {
          type: "selection",
          align: "center",
        },
        {
          title: "学号",
          key: "licenseNo",
        },
        {
          title: "姓名",
          key: "name",
        },
        {
          title: "错误提示",
          key: "errMsg",
        },
      ],
      isShowStudentList: false,
    };
  },

  mounted() {
    this.isShowStudentList = this.$route.query.id;
    this.getShelvesTagList();
    this.getCollegeList();
    this.getStudentList();
    // 编辑
    if (this.$route.query.id) {
      this.updateExperiment();
    }
  },

  methods: {
    //删除学习资料
    delStudentWare(id) {
      this.currentStudy.forEach((item, index) => {
        if (item.id == id) {
          this.currentStudy.splice(index, 1);
        }
      });
    },
    //选中的已有学生名单
    checkOldStudent(select) {
      this.checkOldStudentIDS = select;
      let arr = []; //已经选中的
      this.checkOldStudentIDS.forEach((item) => {
        arr.push(item.userId);
      });
      for (let i = 0; i < this.oldStudentList.length; i++) {
        if (arr.indexOf(this.oldStudentList[i].userId) == -1) {
          this.oldStudentList[i]._checked = false;
        } else {
          this.oldStudentList[i]._checked = true;
        }
      }
    },
    //选中的导入学生名单
    checkNewStudent(select) {
      this.checkNewStudentIDS = select;
      let arr = []; //已经选中的
      this.checkNewStudentIDS.forEach((item) => {
        arr.push(item.userId);
      });
      for (let i = 0; i < this.newStudentList.length; i++) {
        if (arr.indexOf(this.newStudentList[i].userId) == -1) {
          this.newStudentList[i]._checked = false;
        } else {
          this.newStudentList[i]._checked = true;
        }
      }
    },
    //显示学生名单
    showStudentList() {
      if (!this.isShowStudentList) {
        if (this.newStudentList.length == 0) {
          this.$message({
            message: "您还没有导入学生名单",
            type: "warning",
          });
          return;
        }
        this.dialogTableVisible = true;
        return;
      }
      this.dialogTableVisible = true;
    },
    //获取学生名单
    getStudentList() {
      if (this.$route.query.id) {
        this.$api.experiment
          .getExperimentStudentList(this.$route.query.id)
          .then((res) => {
            if (res.data != null && res.errCode == 0) {
              this.oldStudentList = res.data;
              this.oldStudentList.forEach((item) => {
                this.$set(item, "_checked", true);
              });
            }
          });
      }
    },
    //编辑实验
    updateExperiment() {
      this.$api.experiment.queryExperiment(this.$route.query.id).then((res) => {
        if (res.errCode == 0) {
          this.updateExperimentObj = res.data;
          this.classHour = res.data.classHour; //学时
          this.collegeId = res.data.collegeId; // 学院id
          this.experimentCover = res.data.cover; //实验封面
          this.$refs.updateUploadFile.OnShow(res.data.cover); //实验封面
          this.currentStudy = res.data.experimentAttachTOS; //学习资料
          this.experimentIntroduce = res.data.introduce; //实验介绍
          this.isPublic = res.data.isPublic == 1 ? true : false; //是否公开
          this.levelVal = res.data.level; //评级认定
          this.experimentName = res.data.name; //实验名称
          this.userIds = res.data.userIds; //之前已经有的
          // params.shelvesStatus = this.status ? 1 : 0= res.data; //是否上架;
          this.subject = res.data.tagId; //标签id
          this.experimentUrl = res.data.url; //虚拟仿真平台地址
        }
      });
    },
    //提交
    save() {
      let params = {};
      if (this.experimentName.trim() === "") {
        this.getTips("实验名称不能为空", "warning");
        return;
      }
      console.log("this.levelVal", this.levelVal);
      if (this.levelVal === "") {
        this.getTips("课程认定不能为空", "warning");
        return;
      }
      if (this.collegeId === "") {
        this.getTips("所属学院不能为空", "warning");
        return;
      }
      if (this.subject === "") {
        this.getTips("学科不能为空", "warning");
        return;
      }
      if (this.classHour === 0) {
        this.getTips("学时不能为0", "warning");
        return;
      }
      if (this.experimentUrl.trim() === "") {
        this.getTips("虚拟仿真链接地址不能为空", "warning");
        return;
      }
      // if (this.userIds.length == 0) {
      //   this.getTips("请上传学生名单", "warning");
      //   return;
      // }
      if (this.experimentCover === "") {
        this.getTips("实验封面不能为空", "warning");
        return;
      }
      if (this.experimentIntroduce === "") {
        this.getTips("实验介绍不能为空", "warning");
        return;
      }
      //可以不上传学习资料
      // if (this.currentStudy.length == 0) {
      //   this.getTips("请上传学习资料", "warning");
      //   return;
      // }
      params.classHour = this.classHour; //学时
      params.collegeId = this.collegeId; // 学院id
      params.cover = this.experimentCover; //实验封面
      params.experimentAttachTOS = this.currentStudy; //学习资料
      params.id = 0; //实验id
      params.introduce = this.experimentIntroduce; //实验介绍
      params.isPublic = this.isPublic ? 1 : 0; //是否公开
      params.level = Number(this.levelVal); //评级认定
      console.log(params);
      params.name = this.experimentName.trim(); //实验名称
      params.schoolId = JSON.parse(localStorage.getItem("USER")).schoolId;
      params.shelvesStatus = 0; //是否上下架;
      params.sortPri = 0; //优先级 默认为0
      params.tagId = this.subject; //标签id
      params.url = this.experimentUrl.trim(); //虚拟仿真平台地址
      this.userIds = [];
      //用户没有点开学生名单去操作
      if (this.checkOldStudentIDS.length == 0) {
        this.oldStudentList.forEach((item) => {
          if (item._checked) {
            this.userIds.push(item.userId);
          }
        });
      } else {
        //用户点开操作了
        this.checkOldStudentIDS.forEach((item) => {
          if (item._checked) {
            this.userIds.push(item.userId);
          }
        });
      }
      if (this.checkNewStudentIDS.length == 0) {
        this.newStudentList.forEach((item) => {
          //没有被禁用的
          if (!item._disabled && item._checked) {
            this.userIds.push(item.userId);
          }
        });
      } else {
        this.checkNewStudentIDS.forEach((item) => {
          if (item._checked) {
            this.userIds.push(item.userId);
          }
        });
      }
      this.checkNewStudentIDS;

      params.userIds = this.userIds; //用户id
      //编辑实验
      if (this.$route.query.id) {
        params.id = this.$route.query.id;
        this.$api.experiment.updateExperiment(params).then((res) => {
          if (res.errCode == 0) {
            this.getTips("修改成功", "success");
            this.$router.push("/experimentList");
          } else {
            this.$message.error(res.errMsg);
          }
        });
        return;
      }
      this.$api.experiment.addExperiment(params).then((res) => {
        if (res.errCode == 0) {
          this.getTips("发布成功", "success");
          this.$router.push("/experimentList");
        } else {
          this.$message.error(res.errMsg);
        }
      });
    },
    uploadCover(url) {
      this.experimentCover = url;
    },
    //上传学习资料
    handleUploadCoverSuccess(file) {
      if (this.currentStudy.length == 5) {
        this.$message({
          message: "最多只能上传5个资源",
          type: "warning",
        });
        return;
      }
      let obj = {
        id: new Date().getTime() + "" + Math.ceil(Math.random() * 100000),
        name: file.name,
        type: "",
        url: file.absolutePath,
      };
      if (file.name.split(".")[file.name.split(".").length - 1] == "pdf") {
        obj.type = 3;
      } else if (
        file.name.split(".")[file.name.split(".").length - 1] == "mp4"
      ) {
        obj.type = 2;
      } else {
        this.$message({
          message: "上传文件的格式错误！只支持pdf和mp4格式的文件",
          type: "success",
        });
        return;
      }
      this.currentStudy.push(obj);
    },
    //获取上架的学科列表
    getShelvesTagList() {
      this.$api.experiment.getShelvesTagList().then((res) => {
        if (res.data != null && res.errCode == 0) {
          this.subjectList = res.data;
        } else {
          this.$message.error(res.errMsg);
        }
      });
    },
    //获取学院列表
    getCollegeList() {
      let params = {
        pageIndex: 1,
        schoolId: JSON.parse(localStorage.getItem("USER")).schoolId,
        showItem: 999,
        word: "",
      };
      this.$api.experiment.getCollegeList(params).then((res) => {
        if (res.data != null && res.errCode == 0) {
          this.collegeList = res.data.items;
        } else {
          this.$message.error(res.errMsg);
        }
      });
    },
    getTime(date) {
      return util.getTime(date);
    },
    // 模板下载
    download() {
      this.$api.common.downloadTemplateExcel().then((data) => {
        const blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          responseType: "blod",
        });
        util.export(blob, "学生导入");
      });
    },
    //点击上传文件
    onClick() {
      this.$refs.uploadFile.value = "";
      this.$refs.uploadFile.click();
    },
    //上传文件标签变动
    onChange() {
      this.userIds = [];
      let schoolId = JSON.parse(localStorage.getItem("USER")).schoolId;
      let formData = new FormData();
      this.uploadFiles = this.$refs.uploadFile.files[0];
      if (this.uploadFiles.size > 1024 * 1024 * 5) {
        this.$message({
          message: "文件大小不能超过5M",
          type: "warning",
        });
        return;
      }
      formData.append("files", this.uploadFiles);
      this.$api.common
        .uploadExperimentStudent(schoolId, formData)
        .then((res) => {
          this.newStudentList = res.data;
          this.newStudentList.forEach((item) => {
            if (item.errMsg == "" || item.errMsg == null) {
              this.$set(item, "_checked", true);
            } else {
              this.$set(item, "_disabled", true);
            }
          });
          res.data.forEach((item) => {
            this.userIds.push(item.userId);
          });
        });
    },

    goBack() {
      history.go(-1);
    },
    goRouter(path) {
      this.$router.push(path);
    },
    //获取提示
    getTips(msg, type) {
      this.$message({
        showClose: true,
        message: msg,
        type: type,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.dialogTitle {
  font-size: 18px;
  font-family: PingFang-SC;
  font-weight: 400;
}
/deep/ .ivu-table-wrapper {
  max-height: 300px;
  overflow-y: auto;
}
/deep/ .ivu-table::before {
  background: none;
}
.addExperiment {
  width: 100%;
  .addExperiment-title {
    span,
    i {
      width: 147px;
      height: 20px;
      font-size: 14px;
      font-family: PingFang-SC;
      font-weight: 400;
      line-height: 20px;
      color: #424346;
      opacity: 1;
      font-style: normal;
    }
    span {
      color: #939393;
      cursor: pointer;
    }
  }
  .addExperiment-content {
    width: 100%;
    margin: 0 auto;
    padding-top: 31px;
    background: #fff;
    padding-bottom: 47px;
    position: relative;
    .list {
      width: 824px;
      margin-bottom: 22px;
      margin: 0 auto 22px;
      .list-top {
        margin-bottom: 8px;
        display: flex;
        justify-content: start;
        .list-top-tabs {
          height: 25px;
          font-size: 14px;
          font-family: PingFang-SC;
          font-weight: 500;
          line-height: 25px;
          color: #1880fa;
          cursor: pointer;
          &:nth-child(1) {
            margin-right: 37px;
          }
        }
        span {
          font-size: 14px;
          font-family: PingFang-SC;
          font-weight: 400;
          line-height: 20px;
          color: #424346;
        }
        i {
          font-size: 14px;
          font-family: PingFang-SC;
          font-weight: 400;
          line-height: 20px;
          color: #d51717;
          font-style: normal;
        }
        em {
          font-size: 14px;
          font-family: PingFang-SC;
          font-weight: 400;
          line-height: 20px;
          color: rgba(147, 147, 147, 0.55);
          opacity: 1;
          margin-left: 12px;
          font-style: normal;
        }
      }
      .list-bottom {
        display: flex;
        justify-content: start;
        align-items: center;
        .experimentalData {
          display: flex;
          justify-content: start;
          box-sizing: border-box;
          .studyFiles {
          }
          .studyName {
            margin-left: 10px;
          }
        }

        .el-input,
        .el-select {
          width: 100%;
          height: 36px;
        }
        .download {
          margin-left: 35px;
          cursor: pointer;
          i {
            color: #1880fa;
          }
          strong {
            font-size: 14px;
            font-family: PingFang-SC;
            font-weight: 400;
            line-height: 20px;
            color: #1880fa;
            font-style: normal;
          }
        }
      }
    }
    .goBack {
      position: absolute;
      top: 20px;
      right: 20px;
    }
  }
  .addExperiment-title {
    margin-bottom: 16px;
    span,
    i {
      font-size: 14px;
      font-family: PingFang-SC;
      font-weight: 400;
      line-height: 20px;
      color: #424346;
      opacity: 1;
    }
    span {
      color: #939393;
      cursor: pointer;
    }
  }
  .btn {
    width: 84px;
    height: 36px;
    border: 1px solid #1880fa;
    border-radius: 4px;
    line-height: 36px;
    font-size: 14px;
    font-family: PingFang-SC;
    font-weight: 400;
    color: #1880fa;
    background: #fff;
    cursor: pointer;
    &:nth-child(2) {
      background: #1880fa;
      color: #fff;
    }
  }
}
.addtabsActive {
  border-bottom: 2px solid #1880fa;
  span {
    color: #1880fa !important;
  }
}

.font14px {
  font-style: normal;
  font-size: 14px;
  font-family: PingFang-SC;
  font-weight: 400;
  line-height: 20px;
  color: rgba(147, 147, 147, 0.55);
}
</style>